import React, { useState, useEffect } from "react";
import { apiClient, baseURL } from "../utils/const";
import { toast } from "react-toastify";

const ShowroomRate = () => {
  const [formData, setFormData] = useState({
    "1_gm": "",
    "2_gm": "",
    "5_gm": "",
    "10_gm": "",
    "20_gm": "",
    "50_gm": "",
    status: "active",
  });
  const [currentPrice, setCurrentPrice] = useState(null);
  const [showroomRates, setShowroomRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // New state variables for the updated form
  const [gold24Input, setGold24Input] = useState("");
  const [gold22Input, setGold22Input] = useState("");
  const [gold18Input, setGold18Input] = useState("");
  const [silverInput, setSilverInput] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [latest, setLatest] = useState(null);
  const schemeBackground = "#dc3545"; // Red color for submit button

  useEffect(() => {
    fetchCurrentPrice();
    fetchShowroomRates();
  }, []);

  const fetchCurrentPrice = async () => {
    try {
      const response = await apiClient.post(
        `${baseURL}/user_api/get_gold_price.php`
      );
      // console.log(response.data);
      if (response.data.message === "radha") {
        setCurrentPrice(response.data.data.latest);
        setLatest(response.data.data.latest);
        setShowroomRates(response.data.data.all || []);
      }
    } catch (err) {
      console.error("Error fetching current showroom rate:", err);
    }
  };

  const fetchShowroomRates = async () => {
    try {
      const response = await apiClient.post(
        `${baseURL}/user_api/get_gold_price.php`
      );
      if (response.data.message === "radha") {
        setShowroomRates(response.data.data.all || []);
      }
    } catch (err) {
      console.error("Error fetching showroom rates:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);

    try {
      const payload = {
        gold_a: gold24Input || "",
        gold_b: gold22Input || "",
        gold_c: gold18Input || "",
        silver: silverInput || "",
      };

      const response = await apiClient.post(
        `${baseURL}/user_api/insert_gold_price.php`,
        payload
      );

      if (response.data.message === "radha") {
        toast.success("Showroom rate added successfully!");
        setGold24Input("");
        setGold22Input("");
        setGold18Input("");
        setSilverInput("");
        fetchCurrentPrice();
        fetchShowroomRates();
      } else {
        setError(response.data.message || "Failed to add showroom rate");
      }
    } catch (err) {
      console.error("Error adding showroom rate:", err);
      setError("Network error while adding showroom rate");
    } finally {
      setSubmitting(false);
    }
  };

  const formatCurrency = (amount) => {
    if (!amount || amount === "—") return "₹ —";
    return `₹${Number(amount).toLocaleString("en-IN")}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    return new Date(dateString).toISOString().split('T')[0];
  };

  const formatIndianNumber = (number) => {
    if (!number) return "—";
    return Number(number).toLocaleString("en-IN");
  };

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="container-xxl">
          {/* Header */}
          <div className="row mb-1">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center bg-body p-2 rounded shadow-sm">
                <h2 className="mb-0 fw-bold">Showroom • Rate</h2>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Add Showroom Rate Card */}
            <div className="col-12 mb-1">
              <div
                className="card"
                style={{
                  borderRadius: 16,
                  padding: 16,
                  boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: "var(--bs-body-color)",
                    marginBottom: 12,
                  }}
                >
                  Add Daily Price
                </div>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "flex-end",
                      flexWrap: "wrap",
                    }}
                  >
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    <label style={{ fontSize: 12, color: "var(--bs-secondary-color)" }}>
                      24K Gold Rate (1gm)
                    </label>
                    <input
                      type="number"
                      value={gold24Input}
                      onChange={(e) => setGold24Input(e.target.value)}
                      placeholder="Enter Gold Rate"
                      className="form-input w-48 rounded-lg border border-slate-300 px-3 py-2"
                    />
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    <label style={{ fontSize: 12, color: "var(--bs-secondary-color)" }}>
                      22K Gold Rate (1gm)
                    </label>
                    <input
                      type="number"
                      value={gold22Input}
                      onChange={(e) => setGold22Input(e.target.value)}
                      placeholder="Enter 22K Gold Rate"
                      className="form-input w-48 rounded-lg border border-slate-300 px-3 py-2"
                    />
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    <label style={{ fontSize: 12, color: "var(--bs-secondary-color)" }}>
                      18K Gold Rate (1gm)
                    </label>
                    <input
                      type="number"
                      value={gold18Input}
                      onChange={(e) => setGold18Input(e.target.value)}
                      placeholder="Enter 18K Gold Rate"
                      className="form-input w-48 rounded-lg border border-slate-300 px-3 py-2"
                    />
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    <label style={{ fontSize: 12, color: "var(--bs-secondary-color)" }}>
                      Silver Rate (1kg)
                    </label>
                    <input
                      type="number"
                      value={silverInput}
                      onChange={(e) => setSilverInput(e.target.value)}
                      placeholder="Enter Silver Rate"
                      className="form-input w-48 rounded-lg border border-slate-300 px-3 py-2"
                    />
                  </div>
                   <button
                     type="submit"
                     disabled={submitting}
                     className="btn h-10 rounded-lg px-4 text-white"
                     style={{ backgroundColor: schemeBackground }}
                   >
                     {submitting ? "Submitting..." : "Submit"}
                   </button>
                 </div>
                 
                 {error && (
                   <div
                     className="alert alert-danger mt-3"
                     role="alert"
                     style={{ fontSize: 12 }}
                   >
                     {error}
                   </div>
                 )}
                </form>
                </div>
              </div>
            </div>

            {/* Current Price Card */}
            <div className="col-12 mb-1">
              <div
                className="card"
                style={{
                  borderRadius: 16,
                  padding: 16,
                  boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: "var(--bs-body-color)",
                    marginBottom: 12,
                  }}
                >
                  Current Price (Last Entry)
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      background: "#eef2ff",
                      borderRadius: 10,
                      padding: 12,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--bs-secondary-color)",
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      Date
                    </div>
                    <div style={{ color: "#0f172a", fontWeight: 700 }}>
                      {latest?.date ? latest.date : "—"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#fff7ed",
                      borderRadius: 10,
                      padding: 12,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--bs-secondary-color)",
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      24K Gold Rate (1gm)
                    </div>
                    <div style={{ color: "#ca8a04", fontWeight: 800 }}>
                      ₹{" "}
                      {latest?.gold_a ? formatIndianNumber(latest.gold_a) : "—"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#fff1f2",
                      borderRadius: 10,
                      padding: 12,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--bs-secondary-color)",
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      22K Gold Rate (1gm)
                    </div>
                    <div style={{ color: "#e11d48", fontWeight: 800 }}>
                      ₹{" "}
                      {latest?.gold_b ? formatIndianNumber(latest.gold_b) : "—"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#ecfeff",
                      borderRadius: 12,
                      padding: 16,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--bs-secondary-color)",
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      18K Gold Rate (1gm)
                    </div>
                    <div style={{ color: "#e11d48", fontWeight: 800 }}>
                      ₹{" "}
                      {latest?.gold_c ? formatIndianNumber(latest.gold_c) : "—"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#ecfeff",
                      borderRadius: 10,
                      padding: 12,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--bs-secondary-color)",
                        fontWeight: 600,
                        marginBottom: 6,
                      }}
                    >
                      Silver Rate (1kg)
                    </div>
                    <div style={{ color: "#06b6d4", fontWeight: 800 }}>
                      ₹{" "}
                      {latest?.silver ? formatIndianNumber(latest.silver) : "—"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Showroom Rates Card */}
            <div className="col-12">
              <div
                className="card border-0 shadow-sm"
                style={{ borderRadius: "12px" }}
              >
                <div
                  className="card-header"
                  style={{ borderRadius: "12px 12px 0 0" }}
                >
                  <h5 className="card-title mb-0 fw-bold">Showroom Rates</h5>
                </div>
                <div className="card-body p-2" style={{ height: '200px', overflowY: 'auto', position: 'relative', zIndex: 1 }}>
                  {showroomRates.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'var(--bs-light)' }}>
                          <tr>
                            <th>Date</th>
                            <th>Admin Name</th>
                            <th>24K Gold (1gm)</th>
                            <th>22K Gold (1gm)</th>
                            <th>18K Gold (1gm)</th>
                            <th>Silver (1kg)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {showroomRates.length > 0 ? (
                            showroomRates.map((rate, index) => (
                              <tr key={index}>
                                <td>{formatDate(rate.date)}</td>
                                <td>{rate.admin_name || "—"}</td>
                                <td>{formatCurrency(rate.gold_a)}</td>
                                <td>{formatCurrency(rate.gold_b)}</td>
                                <td>{formatCurrency(rate.gold_c)}</td>
                                <td>{formatCurrency(rate.silver)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center p-4">
                                No rates found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <i className="fas fa-store text-muted fs-1 mb-3"></i>
                      <p className="text-muted mb-0">No rates found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ShowroomRate;
